<template>
  <div class="list-item" @click="openDetail({ id: data.guid })">
    <div class="overh list-title">{{ data.title }}</div>
    <div class="list-content">
      <div class="overh content-title">当事人：{{ data.btsr }}</div>
      <div class="content-time">{{ commonTime }}</div>
    </div>
  </div>
</template>

<script>
import AdsVue from "@components/sys/ads";
import {ToText, toTime} from "../assets/js/news.js";

export default {
  components: {
    AdsVue,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    detail: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "first",
    },
  },
  data() {
    return {};
  },
  computed: {
    commonTime() {
      if (this.data.addtime) {
        return this.data.addtime.indexOf("-") > -1
          ? this.data.addtime.split(" ")[0]
          : toTime(this.data.addtime, false);
      }
    },
  },
  mounted() {},
  methods: {
    openDetail(row) {
      this.$store.dispatch("analysis/updateHits", {
        visitlocation: `处罚案例-${this.type === 'first' ? '行政处罚' : '行政裁决'}-详情`,
      });
      this.$ajax({
        type: "get",
        url: `${this.$store.state.api.webUrl}/punishment/detail.json`,
        data: {
          guid: row.id,
        },
        callback: (data) => {
          if (data.isView) {
            this.$router.push({
              path: "/punishmentCase/detail?guid=" + row.id + "&activeName=" + this.type,
            });
          } else {
            ShowConfirm("开通会员，一键升级，优质内容任你畅享！", "warning", () => {
              this.$router.push({
                path:
                  "/user/assets/vip?vipType=year_vip&redirectUrl=" +
                  encodeURIComponent(window.location.href),
              });
            });
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.list-item {
  cursor: pointer;
  margin-top: 11px;

  .list-title{
    font-weight: bold;
  }

  .list-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 400;
    font-size: 14px;
    color: #111111;
    line-height: 38px;

    .content-title {
      color: #666666;
    }

    .content-time {
      white-space: nowrap;
      margin-left: 56px;
      color: #666666;
    }
  }
}
</style>
